import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const convertDataSelect = (data) => {
  const convertedData = data.map(d => {
    if (!d.name || !d.id) {
      return d;
    }
    return ({
      label: d.name,
      value: d.id,
      _id: d.id,
    })
  });

  return convertedData;
}

const PublishCategories = ({ userCategories, publishCategories, updatePublishCategories }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const handleOnChange = (value) => {    
    updatePublishCategories(value);
  }

  useEffect(() => {
    if (userCategories) {
      const convertedUserCategories = convertDataSelect(userCategories);
      setCategories(convertedUserCategories);
      // if (!publishCategories || publishCategories.length === 0) {
      //   setSelectedCategories(convertedUserCategories);
      // }
    }
  }, [userCategories]);

  useEffect(() => {
    if (publishCategories && publishCategories.length) {
      setSelectedCategories(convertDataSelect(publishCategories));
    }
  }, [publishCategories]);

  return (
    <Select
      isMulti
      options={categories}
      value={selectedCategories}
      onChange={value => handleOnChange(value)}
    />
  )
}

export default PublishCategories;